import { AnimatedIcon } from '@/shared/components/animated-icon';
import { Card } from '@/shared/ui/card';
import { rewardSentence } from '../../model/copy';
import type { MgmPublicRules, MgmRole } from '../../model/types';
import { ROLE_ICON } from '../../ui/status-icons';

/** "O que cada um ganha", gerado das regras da campanha. */
export function BenefitsCard({ rules }: { rules: MgmPublicRules }) {
  const items = (['referrer', 'referred'] as MgmRole[])
    .filter((role) => rules[role].enabled)
    .map((role) => ({
      role,
      text: rewardSentence(role, rules[role].amountText, rules[role].trigger, 'referrer'),
    }));

  return (
    <Card className="p-5">
      <p className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">Como você ganha</p>
      <ul className="mt-3 space-y-3">
        {items.map((item, i) => (
          <li key={item.role} className="flex items-start gap-3">
            <span className="mgm-accent-soft grid size-9 shrink-0 place-items-center rounded-xl">
              <AnimatedIcon
                icon={ROLE_ICON[item.role]}
                motion={item.role === 'referrer' ? 'wiggle' : 'float'}
                loop
                delay={i * 0.4}
                className="mgm-accent-text size-[18px]"
              />
            </span>
            <p className="pt-1.5 text-sm font-medium leading-snug">{item.text}</p>
          </li>
        ))}
      </ul>
    </Card>
  );
}
